export type Locale = 'en' | 'zh-CN';
export type Currency = 'USD' | 'CNY' | 'KRW';

export const SUPPORTED_LOCALES: readonly Locale[] = ['en', 'zh-CN'];
export const SUPPORTED_CURRENCIES: readonly Currency[] = ['USD', 'CNY', 'KRW'];

/** 서버 금액 형식: 내부 KRW + 요청 통화 표시값 (실행계획 4.4). 클라이언트에서 환산하지 않는다. */
export interface Money {
  krw: number;
  display: {
    currency: Currency;
    amount: number;
    formatted: string;
  };
}
